import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import type { Category } from '@@partner:types:app'
import type { CommonFilter, CommonSort, GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface CategoryQueryResult {
  categoryDetails: Category
}

export interface CategoryQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_CATEGORY = gql`
  query ($id: ID!) {
    categoryDetails(id: $id) {
      id
      xid
      name
      status
      featured
      slug
      customer_order
      assembler_order
      icon_id
      icon {
        url
      }
      alternative_icon_id
      altIcon {
        url
      }

      miniIcon {
        url
      }
      mini_icon_id

      parent {
        id
        name
      }

      i18n {
        language_code
        name
      }

      preview_size
      ignore_exchange_changes
    }
  }
`

export const useFetchSingleCategory = (variables: CategoryQueryVariables) =>
  useQuery<CategoryQueryResult, CategoryQueryVariables>(
    GQL_QUERY_SINGLE_CATEGORY,
    {
      variables,
      skip: !variables.id,
      fetchPolicy: 'cache-and-network'
    }
  )
